<template>
  <div class="page-dealers-cars" :class="{ 'show-menu':showMenu, 'filtered': filtersCount }">
    <vue-headful
        :title="pageTitle"
        description="Description from vue-headful"
    />
    <ad :ad="ad" v-if="filtersCount == 0 && $device.tablet()" :class="{'ad-front-tablet':$device.tablet()}"
        :ad-load="adLoad"/>
    <aside-dealer :class="{'show-menu':showMenu,'filters-with-ad':ad && $device.tablet()}" :filters="filters"/>

    <div v-if="showContentIosApp" class="dealers-wrapper">
      <ad :ad="ad" v-if="filtersCount == 0 && !$device.tablet()" :ad-load="adLoad"/>
      <!--      <transition name="toggle" mode="out-in" :duration="300">-->
      <div class="cars-sliders-wrap preloader-slider" v-if="!dataLoaded">
        <div class="index-slider empty-slider">
          <div class="dealer-car--empty" v-for="n in 5" :key="n">
            <div class="dealer-car-image b-empty shine"></div>
            <div class="dealer-car-title b-empty shine"></div>
            <div class="dealer-car-specifications">
              <div class="specification1 b-empty shine"></div>
              <div class="specification2 b-empty shine"></div>
            </div>
            <div class="dealer-car-specifications">
              <div class="specification3 b-empty shine"></div>
              <div class="specification4 b-empty shine"></div>
            </div>
            <div class="dealer-car-price b-empty shine"></div>
          </div>
        </div>
      </div>
      <div class="cars-sliders-wrap" v-else>
        <template v-for="(val, index) in getSliderCars">
          <DealerCarsSlider
              v-if="!val.ad"
              :key="index"
              :cat_id="val.fuel_id"
              :title="val.title"
              :subtitle="val.title.toLowerCase()"
              :scar="val.cars"
              :girartegund="$store.state.girartegund"
              dealers
          />
          <template v-if="val.ad">
            <ad-car :ad="val" class="mobile-ad-slider" :key="index"/>
            <!--            <single-ad class="mobile-ad-slider" :key="index" :ad="val" />-->
          </template>
        </template>
      </div>
      <!--      </transition>-->
      <div v-if="hasDealerResCars">
        <ResultsHeader
            :filters="addFilersName()"
            :filtersData="filters"
            :total="d.resultCount"
            :is_sub="d.is_sub"
            :subscriber="subscriber"
        />
        <div class="results-cards-wrap" id="results-cards">
          <car
              v-for="(car, i) in this.getCars"
              :key="i"
              :car="car"
              :carInStock="car.status"
              :filter="clearFilters(filters)"
          />
          <div style="font-size: 18px; color: red" id="load_more">
            Load More
          </div>
        </div>
      </div>


      <CarsNotFound
          :filter="addFilersName()"
          v-if="carsNotFound"
          :image="notFoundImage"
          :allow-subscribe="true"
      />
    </div>
    <phone-nav-btn v-if="!$store.state.isApp"/>
    <Footer class="footer-main" v-if="isIosApp && !showMenu"/>
  </div>
</template>

<script>
import {mapState, mapMutations, mapGetters, mapActions} from "vuex";

import AsideDealer from "@/components/Dealers/AsideDealer.vue";
import DealerCarsSlider from "@/components/Dealers/DealerCarsSlider.vue";
import Car from "@/components/global/Car.vue";
import globalNewCar from "@/helpers/globalNewCar";
import ResultsHeader from "@/components/ResultsHeader";
import CarsNotFound from "@/components/Dealers/CarsNotFound";
import AdUnit from "@/components/Dealers/AdUnit";
import MobileAppStore from "@/components/Dealers/MobileAppStore";
import Footer from "@/components/Footer";
import NewBanner from "@/components/global/NewBanner";
import PhoneNavBtn from "@/components/global/PhoneNavBtn";
import ScrollToResBtn from "@/components/Dealers/ScrollToResBtn.vue";
import Ad from "@/components/ad/Index"
import SingleAd from "@/components/global/ad";
import AdCar from "@/components/global/AdCar";

import fnc from "@/helpers/func";
import scroll from "@/helpers/scroll";
import baseURL from "@/helpers/getBaseUrl";
import dealers from "@/mixins/dealers";
import initCars from "@/mixins/newCars/initCars";
import ad from "@/mixins/newCars/ad";
import allCars from "@/mixins/allCars";
import adSliderCars from "@/mixins/cars/adSliderCars";

export default {
  metaInfo() {
    return {
      title: this.pageTitle,
      //titleTemplate: '%s | bilaskra.is',
      meta: [
        {name: 'og:title', content: 'Bilaskra.is - Leitarvél nýrra bíla frá öllum umboðum'},
        {
          name: 'og:description',
          content: 'Finndu bíla á tilteknu verði, af tiltekinni stærð eða gerð og berðu saman kostina sem umboðin bjóða.'
        },
        {name: 'og:image', content: this.defaultShareImage},
        {name: 'og:height', content: 630},
        {name: 'og:width', content: 1200},
      ],
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  },
  components: {
    AsideDealer,
    DealerCarsSlider,
    Car,
    ResultsHeader,
    AdUnit,
    MobileAppStore,
    CarsNotFound,
    Footer,
    NewBanner,
    PhoneNavBtn,
    ScrollToResBtn,
    Ad,
    SingleAd,
    AdCar
  },
  mixins: [dealers, initCars, ad, allCars, adSliderCars],
  data: () => ({
    filters: {},
    filtersClean: {
      brands: [],
      fuel_type: [],
      transmision: [],
      verd: [],
      affinity: [],
      towing_capacity: [],
      aukahlutir: [],
      drif: [],
      brands_model: [],
      models_id: [],
      company: [],
      sort: {},
      discount: false,
      cat: [],
      engine: [],
      horse_power: [],
      co2: [],
      seats_number:[],
      battery_capacity:[]
    },
    load: false,
    busy: false,
    total_load: 0,
    subscriber: null,
    scrollElem: null,
    ad: null,
    allAd: null,
    adLoad: false,
    showMenuPosition: null
  }),
  methods: {
    ...mapMutations({
      setData: "SET_DATA",
      setSpecialText: 'setSpecialText'
    }),
    ...mapMutations([
      "setShowMenu",
      "setLastCarPageVisit"
    ]),
    ...mapActions({
      'getLib': "GET_LIB",
      'getAd': "ad/GET",
      //'sendViewsAd': 'ad/SEND_VIEWS_STATISTIC'
    }),
    addFilersName() {
      return fnc.addFilersName(this.clearFilters(this.filters), this.d);
    },
    findArr(arr, id) {
      return fnc.findInArr(arr, id, true);
    },
    setFiltersCount(data) {
      this.setData({
        field: "selected_filters_count",
        data,
      });
    },
    clearFilters() {
      return globalNewCar.clearFilters(this.filters);
    },
    setParams() {
      let url = globalNewCar.setUrlParams(this.clearFilters(this.filters));

      if (this.issetUserFriendlyParams) {
        if (url.includes("?")) {
          const curController = this.$router.resolve({name: "DealersCars"});
          url = curController.href + url;
        }
        //this.$router.push({name: "DealersCars"});
      }

      if (this.$route.fullPath != this.$route.path + url.replace("?", "")) {
        this.$router.push(url).catch(e => console.log("Error Route"));
      }
    },
    getParams(d) {
      if (this.issetUserFriendlyParams) {
        let findSecondParam = null;
        let secondParamType = 'models_id';
        if (this.getUrlModel) {
          const getUrlModel = this.getUrlName(this.getUrlModel);

          findSecondParam = this.lib.fuel_type.find(e => this.getUrlName(e.name) === getUrlModel);
          if (findSecondParam) {
            secondParamType = 'fuel_type';
          }

          if (!findSecondParam) {
            findSecondParam = this.lib.new_cars_models.find(e => this.getUrlName(e.model_class) === getUrlModel);
          }

          if (!findSecondParam) {
            findSecondParam = this.lib.girartegund.find(e => this.getUrlName(e.name) === getUrlModel);
            secondParamType = 'transmision';
          }
          if (!findSecondParam) {
            findSecondParam = this.lib.cat_new_cars.find(e => this.getUrlName(e.name) === getUrlModel);
            secondParamType = 'cat';
          }
          if (!findSecondParam) {
            findSecondParam = this.lib.drif.find(e => this.getUrlName(e.name) === getUrlModel);
            secondParamType = 'drif';
          }

          if (!findSecondParam) {
            if (getUrlModel.search('drageni') >= 0) {
              secondParamType = 'affinity';
              findSecondParam = getUrlModel.replace(/[^0-9]/g, '');
            }
            if (getUrlModel.search('drattargeta') >= 0) {
              secondParamType = 'towing_capacity';
              findSecondParam = getUrlModel.replace(/[^0-9]/g, '');
            }

            if (getUrlModel.search('verd') >= 0) {
              secondParamType = 'verd';
              findSecondParam = getUrlModel.replace(/[^0-9]/g, '');
            }
          }
        }

        const getUrlBrand = this.getUrlName(this.getUrlBrand);
        let findBrand = this.lib.brands.find(e => this.getUrlName(e.name) === getUrlBrand);

        if (findBrand) {
          this.filters.brands = [findBrand.id];
        } else {
          this.$router.push('/nyir-bilar/not-found');
        }

        if (findSecondParam && secondParamType === 'models_id') {
          this.filters.models_id = [findSecondParam.model_id];
        }

        if (findSecondParam && ['towing_capacity', 'verd'].includes(secondParamType)) {
          this.filters[secondParamType] = [0, findSecondParam];
        }
        if (findSecondParam && ['affinity'].includes(secondParamType)) {
          this.filters[secondParamType] = [findSecondParam];
        }
        if (findSecondParam && ['fuel_type', 'transmision', 'cat', 'drif'].includes(secondParamType)) {
          this.filters[secondParamType] = [findSecondParam.id];
        }
        this.$store.state.dealerFilterData = this.clearFilters(this.filters);
      } else {
        this.filters = globalNewCar.getParams(d, {...this.filtersClean, sort: this.filters.sort});
      }
    },
    resetFilter() {
      console.log("this.filtersClean",{...this.filtersClean,...this.getDataProps});
      this.filters = JSON.parse(JSON.stringify(this.filtersClean));
    },
    find_diff(arr1, arr2) {
      return globalNewCar.find_diff(arr1, arr2);
    },
    loadMore() {
      /*
            let pageOffsetTop = document.querySelector("html,body").scrollTop + (window.innerHeight - 200);
            if (this.filtersCount == 0) {
              document.querySelectorAll(".index-slider:not(.see-ad)").forEach(e => {
                if (e.offsetTop < pageOffsetTop && e.querySelector(".ad_car_search_block")) {
                  const id = e.querySelector(".ad_car_search_block").getAttribute("data-id");
                  //this.sendViewsAd({id: id, isSlider: 1});

                  //e.classList.add("see-ad");
                }
              });
            } else {
              document.querySelectorAll(".ad_car_search_block:not(.see-ad)").forEach(e => {
                if (e.offsetTop < pageOffsetTop) {
                  //e.classList.add("see-ad");
                  //this.sendViewsAd({id: e.getAttribute("data-id")});
                }
              })
            }
      */

      /*if (document.querySelector("#load_more")) {
        if (
            document.querySelector("html,body").scrollTop + window.innerHeight >
            document.querySelector("#load_more").offsetTop &&
            !this.busy
        ) {
          this.busy = true;
          this.init(this.clearFilters(this.filters));
        }
      }*/
    },
    handleScroll() {
      this.$store.state.dealerCarsTotalLoad = this.total_load;
      this.$store.state.scrollTop = this.$store.state.isApp ? scroll.offsetTopPage() : scroll.offsetTop();

      if (
          this.$store.state.dataCarsLoadedFlag &&
          this.$route.name == "DealersCars"
      ) {
        this.$store.state.scrollPositionPageDealers =
            this.$store.state.scrollTop;
      }
    },
    clickBtn(nameBtn) {
      this.$store.state.selectedContactFormCheckbox = nameBtn;
      scroll.to(document.querySelector(".contact-form-anchor").offsetTop);
    },
    scrolling() {
      if (
          this.$store.state.dataCarsLoadedFlag &&
          this.$route.name == "DealersCars"
      ) {
        let scrollYOffset = this.$store.state.scrollPositionPageDealers;

        setTimeout(() => {
          scroll.to(scrollYOffset);
          this.$store.state.scrollTop = scrollYOffset;
        }, 500);
      }
    }
  },

  async created() {
    const ad = await this.getAd({location: this.searchResult});
    if (ad && ad.data && ad.data.status) {
      this.allAd = ad.data.all_ad;
      this.setAdList(this.allAd);
    }

    if (this.issetUserFriendlyParams) {
      this.load = true;
      await this.getLib();
    }
    this.resetFilter();
    this.getParams();

    if (this.issetUserFriendlyParams) {
      this.init(this.clearFilters(this.filters));
      return;
    }

    this.total_load = this.totalLoad;

    if (!this.dealersResLength) {
      this.init(this.clearFilters(this.filters));
      this.$store.state.filter = this.filters;
    } else {
      this.$store.state.dealers.page.price_f = {mi: 0, ma: 20000000};
      const {mi, ma} = this.$store.state.dealers.page.price_f;
      this.filtersClean.verd = [mi, ma];
      this.$store.state.dataCarsLoadedFlag = true;
      this.scrolling();
    }
  },
  mounted() {
    // this.handleScroll();
    this.scrollElem = window;
    setTimeout(() => {
      // window.addEventListener('load', () => {
      if (this.$device.ios() && this.$store.state.isApp) {
        this.scrollElem = document.querySelector(
            "body.ios.app #main > :nth-child(2)"
        );
      }

      this.scrollElem.addEventListener("scroll", this.handleScroll);
      this.scrollElem.addEventListener("scroll", this.loadMore);
    }, 1000);

    if (window.location.hash) {
      let th = this;
      setTimeout(function () {
        if (window.location.hash == "#contact_form_email") {
          th.clickBtn("email");
        }

        if (window.location.hash == "#contact_form_phone") {
          th.clickBtn("phone");
        }
      }, 2000);
    }
  },

  beforeRouteLeave(to, from, next) {
    if (!['DealerCar', 'DealersCars'].includes(from.name) || !['DealerCar', 'DealersCars'].includes(to.name)) this.$store.state.sorting = null
    this.setLastCarPageVisit(from);
    next();
  },
  beforeDestroy() {
    // document.body.removeEventListener("touchmove", this.handleScroll);
    this.scrollElem.removeEventListener("scroll", this.handleScroll);
    this.scrollElem.removeEventListener("scroll", this.loadMore);
    this.setShowMenu(false);
  },

  destroyed() {
    this.$store.state.dealerFilterData = {};
    this.$store.state.filter = {};
    this.$store.state.dataCarsLoadedFlag = false;
    this.$store.state.sub = 0;
  },

  watch: {
    filters: {
      handler() {
        if (this.load && this.issetUserFriendlyParams) {
          this.$store.state.filter = this.filters;
          return;
        }
        let f = this.clearFilters(this.filters);
        //this.checkBrandsModels();
        this.$store.state.dealerFilterData = f;

        if (this.dealersResLength) {
          this.total_load = 0;
        }

        this.setParams();
        this.init(f, this.filters.sort);

        this.$store.state.filter = this.filters;
        this.showMenuPosition = null;
      },
      deep: true,

    },
    $route(to) {
      if (to.fullPath == "/nyir-bilar" || this.issetUserFriendlyParams) {
        this.resetFilter();
      }

      this.getParams();
      if (this.issetUserFriendlyParams) {
        this.init(this.clearFilters(this.filters));
        return;
      }
    },
  },

  computed: {
    ...mapState(['newBanner']),
    ...mapState({
      defaultShareImage: state => state.defaultShareImage
    }),
    ...mapGetters([
      "showMenu"
    ]),
    ...mapState({
      api: (state) => state.api,
      totalLoad: (state) => state.dealerCarsTotalLoad,
      dataPage: (state) => state.dealers.page,
      dataLoaded: (state) => state.dataCarsLoadedFlag,
      accessToken: (state) => state.access_token,
      filtersCount: (state) => state.selected_filters_count,
      frontPage: (state) => state.ad.frontPage,
      searchResult: (state) => state.ad.searchResult,
      lib: (state) => state.lib,
      asideList:  state => state.newCars.asideList,
    }),
    ...mapGetters(["isIosApp"]),
    d() {
      return this.dataPage;
    },
    hasDealerResCars() {
      return this.d.res && this.d.res.length;
    },
    hasDealerCars() {
      return this.d.cars && Object.keys(this.d.cars).length;
    },
    carsNotFound() {
      return !this.hasDealerResCars && !this.hasDealerCars && this.dataLoaded;
    },
    dealersResLength() {
      return this.dataPage && this.dataPage.res && this.dataPage.res.length;
    },
    notFoundImage() {
      return `${baseURL()}/img/no-results.png`;
    },
    pageTitle() {
      this.setSpecialText(null);
      if (this.issetUserFriendlyParams) {
        const filterName = this.addFilersName();
        //let specialText = filterName.map(e => e.name);
        //this.setSpecialText(`Nýir ${specialText.join(" ")} bílar`);

        let firstParam = filterName && filterName.length > 0 ? filterName[0].name : '';

        let carTextPosition = null
        if (filterName.length === 2 && ['affinity', 'towing_capacity'].includes(filterName[1].type)) {
          carTextPosition = 1;
        }

        if (filterName.length === 2 && ['drif'].includes(filterName[1].type)) {
          carTextPosition = 2;
        }

        let lastParam = filterName.length === 2 ? filterName[1].name : '';

        this.setSpecialText(`Nýir ${firstParam}${carTextPosition === 1 ? ' bílar ' : ' '}${lastParam}${carTextPosition === 2 ? ' bílar ' : ' '}`);
        return this.$store.state.specialText + ' | bilaskra.is';
      }
      return (this.$route.name === "DealersCars"
          ? "Nýir bílar"
          : "Kjarabílar") + ' | bilaskra.is';
    },
    getCars() {
      const ads = this.d.res.reduce((filtered, item, i) => {
        if (item.ad) {
          filtered.push({ad: item, index: i});
        }
        return filtered;
      }, []);
      let withPrices = this.d.res.filter(car => !car.ad && car.price)
      const withoutPrices = this.d.res.filter(car => !car.ad && !car.price)

      const sorting = this.$store.state.sorting || this.filters.sort
      if (!sorting || !sorting.title || sorting.title.includes('Verð, lægsta fyrst')) {
        withPrices.sort((a, b) => {
          return (+a.discount || +a.price) - (+b.discount || +b.price)
        })
      } else if (sorting.title.includes('Verð, hæsta fyrst')) {
        withPrices.sort((a, b) => {
          return (+b.discount || +b.price) - (+a.discount || +a.price)
        })
      } else if (sorting.field === 'discount') {
        const withDiscount = withPrices.filter(c => +c.discount)
        const withoutDiscount = withPrices.filter(c => !+c.discount)

        withDiscount.sort((a, b) => {
          return +b.price - +b.discount - +a.price + +a.discount
        })
        withPrices = withDiscount.concat(withoutDiscount)
      }
      const res = withPrices.concat(withoutPrices)
      ads.forEach(ad => res.splice(ad.index, 0, ad.ad))
      return res;
      //return this.$store.state.dealers.resCars;
    },
    getDataProps(){
      let res = {};
      _.map(this.asideList, e => {
        console.log(e);
        let n = e.name;
        res[n] = [];
      });
      console.log("res",res);
      return res;
    }
  },
};
</script>
